export const getPageNumbers = ({
  currentPage,
  totalPages,
}: {
  currentPage: number;
  totalPages: number;
}) => {
  const maxLoopPageNum = 5;
  const pageNumbers: Array<'...' | number> = [];
  const ellipsis = '...';

  // When whole pages are less than maxLoopPageNum
  if (totalPages <= maxLoopPageNum) {
    for (let i = 1; i <= totalPages; i += 1) {
      pageNumbers.push(i);
    }

    return pageNumbers;
  }

  // When currentPage is near the start
  if (currentPage <= 3) {
    for (let i = 1; i <= maxLoopPageNum; i += 1) {
      pageNumbers.push(i);
    }
    pageNumbers.push(ellipsis);
    pageNumbers.push(totalPages);

    return pageNumbers;
  }

  // When currentPage is near the end
  if (currentPage >= totalPages - 2) {
    pageNumbers.push(1);
    pageNumbers.push(ellipsis);
    for (let i = totalPages - (maxLoopPageNum - 1); i <= totalPages; i += 1) {
      pageNumbers.push(i);
    }

    return pageNumbers;
  }

  // When currentPage is in the middle
  pageNumbers.push(1);
  pageNumbers.push(ellipsis);

  for (let i = currentPage - 1; i <= currentPage + 1; i += 1) {
    pageNumbers.push(i);
  }
  pageNumbers.push(ellipsis);
  pageNumbers.push(totalPages);

  return pageNumbers;
};
